function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { V1View } from '@intercom/interblocks.ts';
export default class HtmlBlockView {
  constructor(node, config) {
    _defineProperty(this, "dom", void 0);
    _defineProperty(this, "htmlView", void 0);
    this.dom = document.createElement('div');
    let innerDom = document.createElement('div');
    this.dom.appendChild(innerDom);
    this.dom.classList.add('embercom-prosemirror-composer-html-block');
    innerDom.classList.add('intercom-interblocks-html-block');
    let isTemplated = true;
    this.htmlView = new V1View(innerDom, isTemplated, config.templating?.resolver);
    try {
      this.htmlView.render([{
        type: 'html',
        content: node.attrs.content,
        header: null,
        footer: null
      }], {
        skipStyleValidation: true
      });
    } catch (e) {
      console.log(e);
    }
  }
}